import { rooms } from "./memory-palace/rooms";
import { useState, useEffect } from "react";
import { markComplete } from "../utils/progress";
import { saveJournalEntry } from "../services/journal";
import palaceMap from "./memory-palace/assets/memorypalace.webp";
import {
    optimiseAssignments
} from "./memory-palace/optimiseAssignments";
import {
    generateHooks
} from "./memory-palace/hooks";
import Attic from "./memory-palace/assets/Attic.webp";
import Bathroom from "./memory-palace/assets/Bathroom.webp";
import Cellar from "./memory-palace/assets/Cellar.webp";
import DiningRoom from "./memory-palace/assets/Dining Room.webp";
import EntranceHall from "./memory-palace/assets/Entrance Hall.webp";
import FamilyRoom from "./memory-palace/assets/Family Room.webp";
import Garage from "./memory-palace/assets/Garage.webp";
import Hallway from "./memory-palace/assets/Hallway.webp";
import Imaginarium from "./memory-palace/assets/Imaginarium.webp";
import JewelryBox from "./memory-palace/assets/Jewelry Box.webp";
import Kitchen from "./memory-palace/assets/Kitchen.webp";
import Laundry from "./memory-palace/assets/Laundry.webp";
import MusicRoom from "./memory-palace/assets/Music Room.webp";
import Nursery from "./memory-palace/assets/Nursery.webp";
import Orchard from "./memory-palace/assets/Orchard.webp";
import Pantry from "./memory-palace/assets/Pantry.webp";
import QuietRoom from "./memory-palace/assets/Quiet Room.webp";
import RecreationRoom from "./memory-palace/assets/Recreation Room.webp";
import Study from "./memory-palace/assets/Study.webp";
import TeaRoom from "./memory-palace/assets/Tea Room.webp";
import UtilityRoom from "./memory-palace/assets/Utility Room.webp";
import ViewingDeck from "./memory-palace/assets/Viewing Deck.webp";
import Wardrobe from "./memory-palace/assets/Wardrobe.webp";
import Xterior from "./memory-palace/assets/Xterior.webp";
import YogaRoom from "./memory-palace/assets/Yoga Room.webp";
import Zoo from "./memory-palace/assets/Zoo.webp";

const roomImages = {
    "Attic": Attic,
    "Bathroom": Bathroom,
    "Cellar": Cellar,
    "Dining Room": DiningRoom,
    "Entrance Hall": EntranceHall,
    "Family Room": FamilyRoom,
    "Garage": Garage,
    "Hallway": Hallway,
    "Imaginarium": Imaginarium,
    "Jewelry Box": JewelryBox,
    "Kitchen": Kitchen,
    "Laundry": Laundry,
    "Music Room": MusicRoom,
    "Nursery": Nursery,
    "Orchard": Orchard,
    "Pantry": Pantry,
    "Quiet Room": QuietRoom,
    "Recreation Room": RecreationRoom,
    "Study": Study,
    "Tea Room": TeaRoom,
    "Utility Room": UtilityRoom,
    "Viewing Deck": ViewingDeck,
    "Wardrobe": Wardrobe,
    "Xterior": Xterior,
    "Yoga Room": YogaRoom,
    "Zoo": Zoo
};
Object.values(roomImages).forEach(src => {

    const img = new Image();

    img.src = src;

});

const practiceAssignments = [

    {
        item: "Lantern",
        object: "lantern",
        hook:
            "The lantern blazes so brightly it lights every corner of the attic."
    },

    {
        item: "Sink",
        object: "sink",
        hook:
            "The sink erupts like a fountain, blasting water across the bathroom."
    },

    {
        item: "Skeleton",
        object: "skeleton",
        hook:
            "The skeleton suddenly stands up and rattles its bones across the cellar."
    },

    {
        item: "Chair",
        object: "chair",
        hook:
            "The chair grows giant and towers above the dining room table."
    },

    {
        item: "Clock",
        object: "grandfather clock",
        hook:
            "The clock strikes thirteen and shakes the entire entrance hall."
    },

    {
        item: "Fireplace",
        object: "fireplace",
        hook:
            "The fireplace roars like a furnace, shooting sparks across the family room."
    },

    {
        item: "Toolbox",
        object: "toolbox",
        hook:
            "The toolbox bursts open, scattering tools across the garage."
    },

    {
        item: "Window",
        object: "window",
        hook:
            "The window swings open and a freezing wind races down the hallway."
    },

    {
        item: "Dragon",
        object: "dragon",
        hook:
            "The dragon crashes through the imaginarium breathing fire everywhere."
    },

    {
        item: "Crown",
        object: "crown",
        hook:
            "The crown rises into the air, scattering diamonds across the jewelry box."
    },

    {
        item: "Stove",
        object: "stove",
        hook:
            "The stove glows red-hot and launches pots toward the ceiling."
    },

    {
        item: "Basket",
        object: "basket",
        hook:
            "The basket overflows with clothes that spill across the laundry."
    },

    {
        item: "Piano",
        object: "piano",
        hook:
            "The piano plays itself while keys fly through the music room."
    },

    {
        item: "Teddy",
        object: "teddy bear",
        hook:
            "The teddy bear grows giant and stomps around the nursery."
    },

    {
        item: "Apple",
        object: "apple",
        hook:
            "The apple swells to the size of a carriage in the orchard."
    },

    {
        item: "Bread",
        object: "bread",
        hook:
            "The loaf of bread grows so large it fills the entire pantry."
    },

    {
        item: "Pillow",
        object: "pillow",
        hook:
            "The pillow floats gently around the quiet room without touching the floor."
    },

    {
        item: "Darts",
        object: "darts",
        hook:
            "The darts shoot from the board and circle the recreation room."
    },

    {
        item: "Globe",
        object: "globe",
        hook:
            "The globe spins wildly, blurring every country on its surface."
    },

    {
        item: "Teapot",
        object: "teapot",
        hook:
            "The teapot whistles loudly and fills the tea room with steam."
    },

    {
        item: "Hammer",
        object: "hammer",
        hook:
            "The hammer pounds nails by itself throughout the utility room."
    },

    {
        item: "Eagle",
        object: "eagle",
        hook:
            "The eagle circles above the viewing deck and screeches across the sky."
    },

    {
        item: "Jacket",
        object: "jacket",
        hook:
            "The jacket flaps through the wardrobe as if blown by a storm."
    },

    {
        item: "Chimney",
        object: "chimney",
        hook:
            "The chimney erupts with smoke that covers the entire exterior."
    },

    {
        item: "Candle",
        object: "candle",
        hook:
            "The candle burns with a golden flame that fills the yoga room with light."
    },

    {
        item: "Lion",
        object: "lion",
        hook:
            "The lion roars so loudly that every cage in the zoo rattles."
    }

];
function scrollTop() {

    requestAnimationFrame(() => {

        window.scrollTo(0, 0);

        try {
            window.parent.scrollTo(0, 0);
        } catch (e) { }

    });

}
export default function App() {

    const [screen, setScreen] =
        useState("intro");
    const [items, setItems] = useState([]);
    const [itemText, setItemText] = useState("");
    const [assignments, setAssignments] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [currentStage, setCurrentStage] = useState(1);
    const [score, setScore] = useState(null);
    const [loadingAI, setLoadingAI] =
        useState(false);
    const [roomLearnIndex, setRoomLearnIndex] = useState(0);
    const [roomQuizIndex, setRoomQuizIndex] = useState(0);
    const [revealed, setRevealed] = useState(false);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [selectedImage, setSelectedImage] =
        useState(null);
    const stageStart = (currentStage - 1) * 5;
    const stageEnd = currentStage === 5
        ? 26
        : Math.min(stageStart + 5, 26);
    const [showRoomName, setShowRoomName] = useState(false);
    useEffect(() => {

        setShowRoomName(false);

    }, [currentQuestion]);
    const [
        currentAssignment,
        setCurrentAssignment
    ] = useState(0);
    const [mistakes, setMistakes] =
        useState([]);
    const [saved, setSaved] = useState(false);
    useEffect(() => {

        scrollTop();

    }, [screen]);
    useEffect(() => {

        async function finishActivity() {

            if (
                saved ||
                screen !== "results" ||
                stageEnd < assignments.length ||
                assignments.length === 0
            ) {
                return;
            }

            markComplete("memory-palace");

            await saveJournalEntry(
                "memory-palace",
                {
                    moduleId: "think-clearly",
                    activityId: "memory-palace",
                    activityTitle: "Memory Palace",

                    summary:
                        "You practised using the Memory Palace technique by linking information to familiar locations and vivid mental imagery. Organising information into meaningful associations makes information much easier to remember.",

                    score,

                    metadata: {
                        stage: currentStage,
                        totalItems: assignments.length,
                        mistakes: mistakes.length,
                        customPalace: items.length > 0
                    }
                }
            );
            setSaved(true);
        }

        finishActivity();

    }, [
        screen,
        stageEnd,
        assignments,
        score,
        saved
    ]);
    function startPracticeList() {

        setAssignments(
            practiceAssignments
        );

        setCurrentStage(1);

        setCurrentQuestion(0);

        setAnswers([]);

        setScreen(
            "assignments"
        );

    }

    function resetGame() {
        setItems([]);
        setAssignments([]);
        setAnswers([]);
        setCurrentQuestion(0);
        setCurrentStage(1);
        setScore(null);

        setRoomLearnIndex(0);
        setRoomQuizIndex(0);
        setRevealed(false);

        setItemText("");
        setScreen("intro");
    }

    async function buildPalace(suppliedItems = items) {
        setLoadingAI(true);
        setScreen("loading");
        const availableRooms =
            rooms.slice(
                0,
                suppliedItems.length
            );

        try {

            const result =
                await optimiseAssignments(
                    suppliedItems,
                    availableRooms
                );

            const hookResult =
                await generateHooks(
                    result.assignments,
                    availableRooms
                );

            setAssignments(
                hookResult.assignments
            );

        }

        catch (error) {

            console.error(error);

            alert(
                "Unable to contact the AI service. Please try again."
            );

            setLoadingAI(false);

            setScreen("welcome");

            return;

        }
        setLoadingAI(false);
        setRoomLearnIndex(0);

        setScreen(
            "assignments"
        );

    }
    function calculateScore() {

        let correct = 0;

        const wrong = [];

        const target = Math.min(
            currentStage === 5
                ? 26
                : currentStage * 5,
            assignments.length
        );

        for (let i = 0; i < target; i++) {

            const userAnswer =
                (answers[i] || "")
                    .trim()
                    .toLowerCase();

            const correctAnswer =
                assignments[i].item
                    .trim()
                    .toLowerCase();

            if (
                userAnswer ===
                correctAnswer
            ) {

                correct++;

            } else {

                wrong.push({

                    letter:
                        String.fromCharCode(
                            65 + i
                        ),

                    correct:
                        assignments[i].item,

                    entered:
                        answers[i] || ""

                });

            }

        }

        setMistakes(wrong);

        setScore(correct);

    }
    return (
        <div
            className="app"
            style={{
                maxWidth: "1100px",
                margin: "0 auto",
                padding: "20px"
            }}
        >
            {(selectedRoom || selectedImage) && (

                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.9)",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px"
                    }}
                >

                    <img
                        src={
                            selectedRoom
                                ? roomImages[selectedRoom]
                                : selectedImage
                        }
                        alt=""
                        style={{
                            maxWidth: "95%",
                            maxHeight: "85vh",
                            borderRadius: "12px"
                        }}
                    />

                    <button
                        style={{
                            marginTop: "20px",
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        onClick={() => {

                            setSelectedRoom(null);
                            setSelectedImage(null);

                        }}
                    >
                        Back
                    </button>

                </div>

            )}
            {screen === "intro" && (

                <div className="card">

                    <h1
                        style={{
                            fontSize: "2.25rem",   // 36px
                            marginBottom: "24px",
                            lineHeight: 1.3
                        }}
                    >
                        🗝️ Welcome to the Memory Palace
                    </h1>

                    <p>
                        Memory works best when information
                        is connected to places, images and
                        existing knowledge.
                    </p>

                    <p>
                        The Memory Palace technique stores
                        information inside familiar rooms. </p>
                    <p>Instead of memorising isolated facts,
                        you create vivid mental scenes and
                        associations that are easier to
                        recall later.
                    </p>

                    <button
                        style={{
                            width: "100%",
                            minHeight: "50px",
                            fontSize: "16px",
                            marginTop: "20px"
                        }}
                        onClick={() =>
                            setScreen("welcome")
                        }
                    >
                        Enter Palace
                    </button>

                </div>

            )}
            {screen === "welcome" && (
                <div className="card">

                    <h1
                        style={{
                            textAlign: "center",
                            marginBottom: "24px",
                            lineHeight: 1.3
                        }}
                    >
                        🗝️ Memory Palace
                    </h1>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "stretch",
                            gap: "16px",
                            flexWrap: "wrap",
                            marginBottom: "28px"
                        }}
                    >

                        <button
                            style={{
                                flex: "1 1 260px",
                                maxWidth: "320px",
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            onClick={() => setScreen("learnPalace")}
                        >
                            Palace Reference Guide
                        </button>

                        <button
                            style={{
                                flex: "1 1 260px",
                                maxWidth: "320px",
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            onClick={startPracticeList}
                        >
                            Practice List
                        </button>

                        <button
                            style={{
                                flex: "1 1 260px",
                                maxWidth: "320px",
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            onClick={() => setScreen("custom")}
                        >
                            Build My Own Palace
                        </button>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >

                        <img
                            src={palaceMap}
                            alt="Memory Palace"
                            onClick={() =>
                                setSelectedImage(palaceMap)
                            }
                            style={{
                                width: "100%",
                                maxWidth: "800px",
                                borderRadius: "16px",
                                cursor: "pointer"
                            }}
                        />

                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px"
                        }}
                    >

                    </div>

                </div>
            )}

            {screen === "learnPalace" && (

                <div className="card">

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>Palace Reference Guide</h1>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(220px, 1fr))",

                            gap: "20px"
                        }}
                    >

                        {rooms.map((room) => (

                            <img
                                key={room.name}
                                src={roomImages[room.name]}
                                alt=""
                                onClick={() =>
                                    setSelectedRoom(room.name)
                                }
                                style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    borderRadius: "12px"
                                }}
                            />

                        ))}

                    </div>

                    <button
                        style={{
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        onClick={() => setScreen("welcome")}
                    >
                        Home
                    </button>

                </div>

            )}

            {screen === "custom" && (
                <div className="card">

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>Build My Own Palace</h1>
                    <p> Enter on a new line each up to 26 items that you would like to remember.</p>
                    <textarea
                        rows={12}
                        value={itemText}
                        onChange={(e) => setItemText(e.target.value)}
                        style={{
                            width: "100%",
                            minHeight: "320px",
                            fontSize: "1rem"
                        }}
                    />

                    <button
                        style={{
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        disabled={loadingAI}
                        onClick={() => {

                            const loadedItems =
                                itemText
                                    .split("\n")
                                    .map(i => i.trim())
                                    .filter(Boolean)
                                    .slice(0, 26);
                            if (loadedItems.length === 0) {

                                alert(
                                    "Please enter at least one item."
                                );

                                return;

                            }
                            setItems(
                                loadedItems
                            );

                            buildPalace(
                                loadedItems
                            );

                        }}
                    >
                        {loadingAI
                            ? "Optimising Palace..."
                            : "Build Palace"}
                    </button>

                </div>
            )}

            {screen === "loading" && (

                <div className="card">

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>
                        🗝️ Building memory palace...
                    </h1>

                    <p>
                        Matching items to rooms (this might take a while)...
                    </p>

                </div>

            )}
            {screen === "learnStageRooms" && (

                <div className="card">

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        <button
                            style={{
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            onClick={resetGame}>
                            🏠 Home
                        </button>
                    </div>

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>Learn New Rooms</h1>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(220px, 1fr))",

                            gap: "20px"
                        }}
                    >

                        {rooms
                            .slice(stageStart, stageEnd)
                            .map((room) => (

                                <img
                                    key={room.name}
                                    src={roomImages[room.name]}
                                    alt=""
                                    onClick={() =>
                                        setSelectedRoom(room.name)
                                    }
                                    style={{
                                        width: "100%",
                                        cursor: "pointer",
                                        borderRadius: "12px"
                                    }}
                                />

                            ))}

                    </div>

                    <button
                        style={{
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        onClick={() => {

                            setRoomQuizIndex(0);
                            setRevealed(false);

                            setScreen("roomQuiz");

                        }}
                    >
                        Review Rooms
                    </button>

                    <button
                        style={{
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        onClick={() =>
                            setScreen("assignments")
                        }
                    >
                        Skip
                    </button>

                </div>

            )}

            {screen === "roomQuiz" && (

                <div className="card">

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        <button
                            style={{
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            onClick={resetGame}>
                            🏠 Home
                        </button>
                    </div>

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>Review Rooms</h1>

                    {!revealed ? (

                        <>

                            <h2 style={{
                                marginBottom: "16px",
                                lineHeight: 1.3
                            }}>

                                {
                                    String.fromCharCode(
                                        65 +
                                        stageStart +
                                        roomQuizIndex
                                    )
                                }

                            </h2>

                            <p>
                                Think of the room.
                            </p>

                            <button
                                style={{
                                    minHeight: "50px",
                                    fontSize: "16px"
                                }}
                                onClick={() =>
                                    setRevealed(true)
                                }
                            >
                                Reveal
                            </button>

                            <button
                                style={{
                                    minHeight: "50px",
                                    fontSize: "16px"
                                }}
                                onClick={() =>
                                    setScreen(
                                        "assignments"
                                    )
                                }
                            >
                                Skip
                            </button>

                        </>

                    ) : (

                        <>

                            <img
                                src={
                                    roomImages[
                                    rooms[
                                        stageStart +
                                        roomQuizIndex
                                    ].name
                                    ]
                                }
                                alt=""
                                style={{
                                    width: "100%",
                                    maxWidth: "900px",
                                    borderRadius: "12px"
                                }}
                            />

                            {roomQuizIndex <
                                (stageEnd -
                                    stageStart -
                                    1) ? (

                                <button
                                    style={{
                                        minHeight: "50px",
                                        fontSize: "16px"
                                    }}
                                    onClick={() => {

                                        setRoomQuizIndex(
                                            roomQuizIndex + 1
                                        );

                                        setRevealed(
                                            false
                                        );

                                    }}
                                >
                                    Next
                                </button>

                            ) : (

                                <button
                                    style={{
                                        minHeight: "50px",
                                        fontSize: "16px"
                                    }}
                                    onClick={() =>
                                        setScreen(
                                            "assignments"
                                        )
                                    }
                                >
                                    Continue
                                </button>

                            )}

                        </>

                    )}

                </div>

            )}

            {screen === "assignments" && (
                <div className="card">

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>

                        Palace Assignments

                        {" "}

                        (A–

                        {
                            String.fromCharCode(
                                64 +
                                Math.min(
                                    currentStage === 5
                                        ? 26
                                        : currentStage * 5,
                                    assignments.length
                                )
                            )
                        }

                        )

                    </h1>

                    {assignments
                        .slice(
                            0,
                            Math.min(
                                currentStage === 5
                                    ? 26
                                    : currentStage * 5,
                                assignments.length
                            )
                        )
                        .map((assignment, index) => (

                            <button
                                key={index}
                                style={{
                                    display: "block",
                                    width: "100%",
                                    marginBottom: "10px",
                                    textAlign: "left"
                                }}
                                onClick={() => {

                                    setCurrentAssignment(
                                        index
                                    );

                                    setScreen(
                                        "visualisation"
                                    );

                                }}
                            >

                                {rooms[index].name}

                                {" → "}

                                {assignment.item}

                            </button>

                        ))}

                    <p>
                        Click on each pairing for a memory aid.
                    </p>

                    <button
                        style={{
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        onClick={() => {

                            setCurrentQuestion(0);

                            setAnswers([]);

                            setScore(null);

                            setScreen("test");

                        }}
                    >
                        Start Recall Test
                    </button>

                </div>
            )}


            {screen === "visualisation" && (

                <div className="card">

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>
                        Assignment
                        {" "}
                        {currentAssignment + 1}
                    </h1>

                    <h2 style={{
                        marginBottom: "16px",
                        lineHeight: 1.3
                    }}>
                        {
                            rooms[
                                currentAssignment
                            ].name
                        }
                    </h2>

                    <p>

                        <strong>
                            Item:
                        </strong>

                        {" "}

                        {
                            assignments[
                                currentAssignment
                            ]?.item
                        }

                    </p>

                    <p>

                        <strong>
                            Object:
                        </strong>

                        {" "}

                        {
                            assignments[
                                currentAssignment
                            ]?.object || ""
                        }

                    </p>

                    <p>

                        <strong>
                            Hook:
                        </strong>

                        {" "}

                        {
                            assignments[
                                currentAssignment
                            ]?.hook || ""
                        }

                    </p>

                    <img
                        src={
                            roomImages[
                            rooms[
                                currentAssignment
                            ].name
                            ]
                        }
                        alt=""
                        style={{
                            width: "100%",
                            maxWidth: "800px",
                            borderRadius: "12px"
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            justifyContent:
                                "space-between",
                            marginTop: "20px"
                        }}
                    >

                        <button
                            style={{
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            disabled={
                                currentAssignment ===
                                stageStart
                            }
                            onClick={() =>
                                setCurrentAssignment(
                                    currentAssignment - 1
                                )
                            }
                        >
                            Previous
                        </button>

                        <button
                            style={{
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            disabled={
                                currentAssignment ===
                                stageEnd - 1
                            }
                            onClick={() => {

                                if (
                                    currentAssignment <
                                    Math.min(
                                        stageEnd - 1,
                                        assignments.length - 1
                                    )
                                ) {

                                    setCurrentAssignment(
                                        currentAssignment + 1
                                    );

                                }

                            }}
                        >
                            Next
                        </button>

                    </div>

                    <button
                        style={{
                            marginTop: "20px",
                            minHeight: "50px",
                            fontSize: "16px"
                        }}
                        onClick={() =>
                            setScreen(
                                "assignments"
                            )
                        }
                    >
                        Back To Assignments
                    </button>

                </div>

            )}
            {screen === "test" && (
                <div className="card">

                    <h1 style={{
                        marginBottom: "16px",
                        lineHeight: 1.3
                    }}>Recall Test</h1>

                    <p style={{
                        marginBottom: "8px",
                        lineHeight: 1.5
                    }}>
                        Walk your palace in order. For each stop,
                        type the item you stored there.
                    </p>

                    <p style={{
                        marginBottom: "20px",
                        color: "#555"
                    }}>
                        Stop {currentQuestion + 1} of{" "}
                        {Math.min(
                            currentStage === 5
                                ? 26
                                : currentStage * 5,
                            assignments.length
                        )}
                    </p>

                    <label
                        htmlFor="recall-answer"
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontSize: "1.15rem",
                            fontWeight: 600,
                            lineHeight: 1.3
                        }}
                    >
                        Location {String.fromCharCode(65 + currentQuestion)}
                        {showRoomName && rooms[currentQuestion]?.name
                            ? ` (${rooms[currentQuestion].name})`
                            : ""}
                        {" — what item did you store here?"}
                    </label>
                    <input
                        id="recall-answer"
                        key={currentQuestion}
                        type="text"
                        autoFocus
                        autoComplete="off"
                        placeholder="Type the item you memorised"
                        style={{
                            width: "100%",
                            maxWidth: "500px",
                            fontSize: "1.2rem",
                            padding: "14px",
                            marginBottom: "20px"
                        }}
                        value={answers[currentQuestion] || ""}
                        onChange={(e) => {

                            const updated = [...answers];

                            updated[currentQuestion] =
                                e.target.value;

                            setAnswers(updated);

                        }}
                        onKeyDown={(e) => {

                            if (e.key === "Enter") {

                                const target = Math.min(
                                    currentStage === 5
                                        ? 26
                                        : currentStage * 5,
                                    assignments.length
                                );

                                if (
                                    currentQuestion <
                                    target - 1
                                ) {

                                    setCurrentQuestion(
                                        currentQuestion + 1
                                    );

                                } else {

                                    setTimeout(() => {

                                        calculateScore();

                                        setScreen("results");

                                    }, 0);


                                }

                            }

                        }}
                    />
                    <button
                        type="button"
                        onClick={() => setShowRoomName(!showRoomName)}
                        style={{
                            marginBottom: "20px"
                        }}
                    >
                        {showRoomName ? "Hide room name" : "Reveal room name"}
                    </button>
                    {currentQuestion <
                        Math.min(
                            currentStage === 5
                                ? 26
                                : currentStage * 5,
                            assignments.length
                        ) - 1 ? (
                        <button
                            style={{
                                minHeight: "50px",
                                minWidth: "120px",
                                fontSize: "16px",
                                padding: "12px 24px"
                            }}
                            onClick={() =>
                                setCurrentQuestion(currentQuestion + 1)
                            }
                        >
                            Next
                        </button>
                    ) : (
                        <button
                            style={{
                                minHeight: "50px",
                                fontSize: "16px"
                            }}
                            onClick={() => {

                                setTimeout(() => {

                                    calculateScore();

                                    setScreen("results");

                                }, 0);

                                setScreen("results");

                            }}
                        >
                            Finish Test
                        </button>
                    )}

                </div>
            )}

            {screen === "results" && (
                <div className="card">

                    <h1 style={{
                        marginBottom: "24px",
                        lineHeight: 1.3
                    }}>Results</h1>

                    <p>

                        Score:

                        {" "}

                        {score}

                        /

                        {

                            Math.min(
                                currentStage === 5
                                    ? 26
                                    : currentStage * 5,
                                assignments.length
                            )

                        }

                    </p>
                    {mistakes.length > 0 && (

                        <>

                            <h2 style={{
                                marginBottom: "16px",
                                lineHeight: 1.3
                            }}>
                                Review Mistakes
                            </h2>

                            {mistakes.map(
                                (mistake, index) => (

                                    <div
                                        key={index}
                                        style={{
                                            marginBottom: "12px",
                                            textAlign: "left"
                                        }}
                                    >

                                        <strong>
                                            {mistake.letter}
                                        </strong>

                                        {" → "}

                                        Correct:

                                        {" "}

                                        {mistake.correct}

                                        <br />

                                        Your answer:

                                        {" "}

                                        {
                                            mistake.entered ||
                                            "(blank)"
                                        }

                                    </div>

                                )
                            )}

                        </>

                    )}

                    {score !== null && (

                        <>
                            {score === assignments.length &&
                                assignments.length === 26 && (

                                    <div
                                        style={{
                                            background: "#d4edda",
                                            padding: "20px",
                                            borderRadius: "12px",
                                            marginBottom: "20px"
                                        }}
                                    >

                                        <h2 style={{
                                            marginBottom: "16px",
                                            lineHeight: 1.3
                                        }}>
                                            🏆 Palace Mastered
                                        </h2>

                                        <p>
                                            You recalled all 26 locations
                                            correctly.
                                        </p>

                                        <p>
                                            Most people struggle to remember
                                            a list of 10 unrelated items.
                                            By connecting information to
                                            locations, objects and vivid
                                            imagery, you successfully
                                            recalled 26 items in order.
                                        </p>

                                    </div>

                                )}
                            <p>
                                Stage Complete
                            </p>

                            {stageEnd < assignments.length ? (

                                <>
                                    <button
                                        style={{
                                            minHeight: "50px",
                                            fontSize: "16px"
                                        }}
                                        onClick={() => {

                                            setCurrentStage(
                                                currentStage + 1
                                            );

                                            setRoomQuizIndex(0);
                                            setRevealed(false);

                                            setScreen(
                                                "assignments"
                                            );

                                        }}
                                    >
                                        Next Stage
                                    </button>

                                    <button
                                        style={{
                                            minHeight: "50px",
                                            fontSize: "16px"
                                        }}
                                        onClick={() => {

                                            setCurrentQuestion(0);

                                            setAnswers([]);

                                            setScreen(
                                                "assignments"
                                            );

                                        }}
                                    >
                                        Review & Retry
                                    </button>
                                </>

                            ) : (

                                <button
                                    style={{
                                        minHeight: "50px",
                                        fontSize: "16px"
                                    }}
                                    onClick={resetGame}
                                >
                                    Build Another Palace
                                </button>

                            )}

                        </>

                    )}

                </div>
            )}


        </div>
    );
}
